import { MUNICIPALITY_LIST } from "./Const";
import { isInternalDestination } from "./safeUrl";

// サブディレクトリごとのリダイレクト先パスを生成する共通関数
// 除外したいセグメントを第2引数で指定可能
export function getRedirectPath(base: string, excludeSegments: string[] = []) {
  if (!isInternalDestination(base)) {
    throw new TypeError("Invalid internal navigation destination");
  }
  // パスを分割
  const segments = window.location.pathname.split("/").filter(Boolean);
  // 除外セグメントを除去
  const filtered = segments.filter((seg) => !excludeSegments.includes(seg));
  // 最初のセグメント（サブディレクトリ）が自治体名リストに含まれていればそれを使う
  const subdir =
    filtered.length > 0 && MUNICIPALITY_LIST.includes(filtered[0])
      ? filtered[0]
      : null;

  let resultPath = base;
  if (subdir) {
    // baseにすでに自治体識別コードが含まれている場合、重複を防止
    if (!base.startsWith(`/${subdir}/`)) {
      resultPath = `/${subdir}${base.startsWith("/") ? base : "/" + base}`;
    }
  } else if (!base.startsWith("/")) {
    // baseが相対パスなら現在のパスに結合
    const currentPath = window.location.pathname.replace(/\/$/, "");
    resultPath = `${currentPath}/${base}`;
  }
  if (!isInternalDestination(resultPath)) {
    throw new TypeError("Invalid internal navigation destination");
  }
  return resultPath;
}
